import React, { useRef, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";

export default function Tile({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const slider = useRef(null);

  const settings = {
    infinite: isMobile,
    speed: 500,
    fade: false,
    autoplaySpeed: 6000,
    autoplay: false,
    dots: false,
    draggable: !!isMobile,
    slidesToShow: isMobile ? 1.2 : 1,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: 0,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    variableWidth: true
  };

  useEffect(() => {
    if (slider.current) {
      slider.current.slickGoTo(0);
    }
  }, [isMobile]);

  const gotoDetail = link => {
    window.open(link);
  };

  const buildCardItem = (tile, index) => {
    return (
      <div className="contentContainer" key={index} to={tile.tilesLink} onClick={() => gotoDetail(tile.tilesLink)}>
        <div className="signature">
          <div className="tileImage">
            <img src={tile.tilesImage.url} alt="tileImage" />
          </div>
          <div className="tileInfo">
            <div className="tilesSubheader">{tile.tilesSubheader}</div>
            <div className="tilesHeader"> {tile.tileHeader} </div>
            <div className="tilesDescription">{tile.tilesDescription}</div>
            {isMobile && (
              <a className="tilesLink" href={tile.tilesLink}>
                Learn more
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };

  const tilesLength = content.tiles.length;
  const lessThanThreeTiles = !isMobile && tilesLength < 3;

  return (
    <div className={`tile ${lessThanThreeTiles ? "tileLessThanThreeTiles" : ""}`}>
      <div className={`tileHeader ${lessThanThreeTiles ? "headerLessThanThreeTiles" : ""}`}>
        <div className={`subheader ${lessThanThreeTiles ? "headerLessThanThreeTiles" : ""}`}>{content.subheader}</div>
        <div className={`header ${lessThanThreeTiles ? "headerLessThanThreeTiles" : ""}`}>{content.header}</div>
        <div className={`description ${lessThanThreeTiles ? "descriptionLessThanThreeTiles" : ""}`}>
          {content.description}
        </div>
      </div>
      {lessThanThreeTiles ? (
        <div className="cardsContainer">{content.tiles.map((tile, index) => buildCardItem(tile, index))}</div>
      ) : (
        <Slider {...settings} ref={slider}>
          {content.tiles.map((tile, index) => buildCardItem(tile, index))}
        </Slider>
      )}
    </div>
  );
}
